import { useRef, memo } from 'react';
import getComponentName from 'react-utils/getComponentName';
import refObject from '../utils/propTypes/refObject';
import { wrapPropTypes } from '../utils/propTypes/wrapPropTypes';
import { attachWrappedComponent } from './utils';

// The MemoExoticComponent type does not allow propTypes.
import { jsx as _jsx } from "react/jsx-runtime";
export default function (Component) {
  const ShareButtonComponent = /*#__PURE__*/memo(props => {
    const defaultRef = useRef(null);
    return /*#__PURE__*/_jsx(Component, Object.assign({}, props, {
      buttonRef: props.buttonRef || defaultRef
    }));
  });
  ShareButtonComponent.propTypes = Object.assign({}, wrapPropTypes(Component), {
    buttonRef: refObject
  });
  ShareButtonComponent.displayName = `ShareButton(${getComponentName(Component)})`;
  attachWrappedComponent(ShareButtonComponent, Component);
  return ShareButtonComponent;
}